import { Injectable } from "@angular/core";
import {
  ModalQueuePriority,
  ModalQueueService,
} from "./modal-queue.service";
import {
  DiagnosticsConsentModalComponent,
  DiagnosticsConsentModalVariant,
} from "src/app/shared/modals/diagnostics-consent-modal/diagnostics-consent-modal.component";

export interface PresentDiagnosticsConsentModalOptions {
  variant?: DiagnosticsConsentModalVariant;
  supportReason?: string;
}

@Injectable({ providedIn: "root" })
export class DiagnosticsConsentModalService {
  constructor(private modalQueue: ModalQueueService) {}

  /**
   * @returns true when the user explicitly accepts / activates diagnostics.
   */
  async present(
    options: PresentDiagnosticsConsentModalOptions = {}
  ): Promise<boolean> {
    const dismissed = await this.modalQueue.enqueueModal<string>(
      {
        component: DiagnosticsConsentModalComponent,
        cssClass: "diagnostics-consent-modal",
        backdropDismiss: false,
        componentProps: {
          variant: options.variant ?? "prompt",
          supportReason: options.supportReason,
        },
      },
      {
        id: "diagnostics-consent",
        priority: ModalQueuePriority.NORMAL_LOW,
      }
    );
    return dismissed?.data === "accept";
  }
}
